import {Directive, ElementRef, Input, Renderer2} from '@angular/core';
import {Item, ItemSliding} from "ionic-angular";

/**
 * Generated class for the SlideItemDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[slide-item]' // Attribute selector
})
export class SlideItemDirective {

  @Input('itemSliding') itemSliding: ItemSliding;
  @Input('item') item: Item;
  @Input('isFound') isFound: boolean;
  @Input('isSwipeable') isSwipeable: boolean;

  elementItemSliding: any;
  elementItem: any;

  constructor(public element: ElementRef, public renderer: Renderer2) {
  }

  ngOnInit() {

    this.elementItemSliding = this.element.nativeElement;
    this.elementItem = this.elementItemSliding.firstElementChild;

    if (this.isSwipeable) {
      // console.log('Swipeable');
      // console.log(this.itemSliding);
      this.renderer.addClass(this.elementItemSliding,"active-slide");
      this.renderer.addClass(this.elementItemSliding,"active-options-right");

      if(this.isFound){
        // console.log('Found');
        // this.renderer.addClass(this.item,"slidingAnimation");
        // this.renderer.setStyle(this.elementItem, "transform", "translate3d(-90px, 0px, 0px)");
        let swipeAmount = 90; //set your required swipe amount
        this.itemSliding.startSliding(swipeAmount);
        this.itemSliding.moveSliding(swipeAmount);

        this.itemSliding.setElementClass('active-options-right', true);
        this.itemSliding.setElementClass('active-swipe-right', true);

        this.item.setElementStyle('transition', null);
        this.item.setElementStyle('transform', 'translate3d(-'+swipeAmount+'px, 0px, 0px)');
      } else {
        // console.log('Not Found');
        // this.renderer.removeClass(this.item,"slidingAnimation");
        this.renderer.setStyle(this.elementItem, "transform", "translate3d(0px, 0px, 0px)");
      }
    } else {
      // console.log('Not Swipeable');
      this.renderer.removeClass(this.elementItemSliding,"active-slide");
      this.renderer.removeClass(this.elementItemSliding,"active-options-right");
      this.renderer.setStyle(this.elementItem, "transform", "translate3d(0px, 0px, 0px)");
    }
  }
}



// WEBPACK FOOTER //
// ./src/directives/slide-item/slide-item.ts